var citiesList = [
'ABBOTTABAD',
'ABDUL HAKEEM',
'ADDA JOHAL',
'ADDA SHAIKH WAHAN',
'ADDA SIRAJ',
'AHMEDPUR EAST',
'AHMEDPUR SIAL',
'AJNIA WALA',
'AKHTAR ABAD',
'AKORA KHATAK',
'ALIPUR',
'ALIPUR CHATHA',
'ALLAH ABAD',
'AMANGARH',
'ARIFWALA',
'ATTOCK',
'AYUBIA',
'BADDOMALHI',
'BADIN',
'BAFFA',
'BAGH (AJK)',
'BAHAWALNAGAR',
'BAHAWALPUR',
'BAHTAR MORE',
'BAIG PUR',
'BALAKOT',
'BALAMBAT',
'BANNU',
'BARA MARKET',
'BARIKOT',
'BASHARAT',
'BASIRPUR',
'BASTI MALOOK',
'BATKHELA',
'BATTAGRAM',
'BHAGTANWALA',
'BHAI PHERU',
'BHAKKAR',
'BHALWAAL',
'BHARA KAHU',
'BHERA',
'BHIKKI',
'BHIMBER (AJK)',
'BHOWANA',
'BHURBUN (P.C. HOTEL)',
'BONGA HAYAT',
'BUCHEKE',
'BUNER',
'BUREWALA',
'CADET COLLEGE SUNNY BANK',
'CHAK JHUMRA',
'CHAK PARANA',
'CHAKDARA',
'CHAKLALA',
'CHAKRI',
'CHAKWAL',
'CHAMAN',
'CHANGA MANGA',
'CHAR BAGH',
'CHARSADDA',
'CHAWINDA',
'CHICHAWATNI',
'CHINIOT',
'CHISTIAN',
'CHITRAL',
'CHOA SAIDAN SHAH',
'CHOR',
'CHOTA LAHORE',
'CHOWK AZAM',
'CHOWK PANDORI',
'CHUNIAN',
'DADU',
'DADYAL (AJK)',
'DAKWALA',
'DAOOD ZAI',
'DARGAI',
'DARYA KHAN',
'DASKA',
'DAUL TALA',
'DEHARKI',
'DEPALPUR',
'DERA ALLAH YAR',
'DERA GHAZI KHAN',
'DERA ISMAIL KHAN',
'DERA MURAD JAMALI',
'DERA NAWAB',
'DEWALAY',
'DHABJEE',
'DHUDIAL',
'DIGRI',
'DIJKOT',
'DINA',
'DINGA',
'DISTT. COMPLEX',
'DOABA',
'DOKRI',
'DONGA BONGA',
'DULLE WALA',
'DUNIAPUR',
'F.F.C. PLANT',
'FAISALABAD',
'FAQIRWALI',
'FAROKA',
'FAROOQABAD',
'FATEH JANG',
'FATEH PUR',
'FATEH PUR KAMAL',
'FAZIL PUR',
'FEROZ WATWAN',
'FORT ABBAS',
'GAGGO MANDI',
'GAMBAT',
'GAMBER',
'GARHA MORE',
'GATWALA 199 / RB',
'GHAKKAR MANDI',
'GHAR MORE',
'GHARI HABIBULLAH',
'GHARIBWAL CEMENT',
'GHARO',
'GHAZI',
'GHAZIABAD',
'GHIKA GALI',
'GHORA GALI',
'GHOTKI',
'GHOUR GHUSTI',
'GHOUS PUR',
'GILGIT',
'GOJRA',
'GOLARCHI',
'GOTH MACHI',
'GUJAR KHAN',
'GUJRANWALA',
'GUJRAT',
'GULYANA',
'GWADAR',
'HAFIZABAD',
'HAJEERA',
'HAKIM ABAD',
'HALA',
'HANGU',
'HARAPPA',
'HARIPUR',
'HARNAL',
'HAROONABAD',
'HASEEB WAQAS MILLS',
'HASIL PUR',
'HASSAN ABDAL',
'HATIA BALA',
'HATTAR',
'HAVELI LAKHA',
'HAVELIAN',
'HAZARA UNIVERSITY',
'HAZRO',
'HEAD BALOKI ROAD',
'HEADMARALA',
'HUB CHOWKI',
'HUJRA SHAH MUKEEM',
'HUSRI',
'HYDERABAD',
'IQBAL ABAD',
'IQBAL NAGAR',
'ISLAMABAD',
'JACOBABAD',
'JAFARABAD',
'JAHANIAN',
'JALALPUR BHATTIAN',
'JALALPUR JATTAN',
'JALALPURPIRWALA',
'JAMPUR',
'JAMSHORO',
'JANDIA SHER KHAN',
'JARANWALA',
'JATOI',
'JEHANGIRA',
'JHABRAN MANDI',
'JHANG',
'JHELUM',
'JOHARABAD',
'JOHI',
'KABIRWALA',
'KACHA KHOO',
'KAHAUTA',
'KALLAR KAHAR',
'KALLAR SYEDDAN',
'KALOR KOT',
'KAMALIA',
'KAMOKE',
'KAMRA',
'KAND KOT',
'KANDIARO',
'KANGAN PUR',
'KANGRA',
'KANJU',
'KANYAL',
'KARACHI',
'KARAK',
'KARAM PUR',
'KAROOR PAKA',
'KAROR LAL EASAN',
'KASHMORE',
'KASSOWAL',
'KASUR',
'KHAIRPUR MEERUS',
'KHAIRPUR',
'KHAIRPUR TAMEWALI',
'KHAN BELA',
'KHAN GHAR',
'KHANEWAL',
'KHANKA DOGRAN',
'KHANPUR',
'KHANPUR MAHAR',
'KHARIAN',
'KHAS BEHAAL',
'KHOAZA KHAILA',
'KHOSKI',
'KHUDIAN KHAS',
'KHURRIANWALA',
'KHUSHAB',
'KHWERA',
'KOHAT',
'KOT ADDU',
'KOT CHUTTA',
'KOT MITHAN',
'KOT MOMIN',
'KOT PINDI DAS',
'KOT RADHA KISHAN',
'KOT SAMABAH',
'KOTLA ARAB ALI KHAN',
'KOTLI (AJK)',
'KOTLI BEHRAM',
'KOTLI LOHARAN',
'KOTRI',
'KUCHLAK',
'KULACHI',
'KUNDIAN',
'KUNRI',
'LAHORE',
'LAKKI MARWAT',
'LALA MUSA',
'LALIAN',
'LALLIAN',
'LALLIANI',
'LARKANA',
'LAWRENCE PUR',
'LAYYAH',
'LIAQAT PUR',
'LODHRAN',
'LORALAI',
'LOWER DIR',
'LOWER TOPA',
'MACHIKEY',
'MAILSI',
'MALAKAND',
'MALAKWAL',
'MAMU KANJAN',
'MANA WLA',
'MANAWALA',
'MANDI BAHAUDDIN',
'MANDI SAFDAR ABAD',
'MANDI USMAN WALA',
'MANDIAN',
'MANDRA',
'MANGA MANDI',
'MANGLA (AJK)',
'MANGLA CANTT (AJK)',
'MANKERA',
'MANKYLA STATION',
'MANSEHRA',
'MARDAN',
'MARI',
'MASAR CAMP',
'MATIARI',
'MATLI',
'MATTA',
'MEHER',
'MEHRAB PUR',
'MIAN CHANNU',
'MIAN WALI QURESHAIN',
'MIANI',
'MIANWALI',
'MINCHINABAD',
'MINGORA',
'MIR PUR METHELO',
'MIRPUR (AJK)',
'MIRPUR KHAS',
'MITHA TIWANA',
'MITTHI',
'MORE AIMANABAD',
'MORE KHUNDA',
'MORO',
'MOTRA',
'MUCH',
'MULTAN',
'MURIDKE',
'MURREE',
'MUZAFFARABAD (AJK)',
'MUZAFFARGARH',
'NANKANA SAHIB',
'NARANG MANDI',
'NAROWAL',
'NASIRABAD',
'NATHIA GALI',
'NAUSHAHRO FEROZE',
'NAWABSHAH',
'NAWAN SHEHR',
'NAWAY KALI',
'NIZAMABAD',
'NOKHAR',
'NONAR',
'NOOR COLONY',
'NOOR KOT',
'NOORPUR',
'NOORPUR THAL',
'NORIABAD',
'NOWSHERA',
'NOWSHERA KALAN',
'NOWSHERA VIRKAN',
'NRTC (TELECOM STAFF COLLEGE)',
'NUDEARO',
'OKARA',
'OLD HALA',
'P.O.F. (FACTORY & COLONY)',
'PABI',
'PAHARPUR',
'PAKPATTAN',
'PANOAQIL',
'PAROA',
'PASROOR',
'PASROOR ROAD AND VILLAGES',
'PATOKI',
'PATRIATA',
'PEER MAHAL',
'PESHAWAR',
'PEZU',
'PHALIA',
'PHOOL NAGAR',
'PIND DADAN KHAN',
'PINDI BHATIAN',
'PINDI GHEB',
'PINDI GUJRAN',
'PIPLAN',
'PIR BABA',
'PISHIN',
'PITARO',
'PMA KAKUL',
'POONCH (AJK)',
'PUNGIRAYIN',
'PUNWAN',
'QABAL',
'QABOOLA SHARIF',
'QADIR PUR RAWAN',
'QAIDABAD',
'QAMAR MASHANI',
'QASBA GUJRAT.',
'QAZI AHMED',
'QILA DEEDAR SING',
'QILA SAIB SINGH',
'QUETTA',
'RADHAN',
'RAHIM YAR KHAN',
'RAIWIND',
'RAJA JANG',
'RAJANA',
'RAJANPUR',
'RAJAR',
'RAMAK',
'RANI PUR',
'RAO KHAN WALA',
'RASHAKI',
'RATO DEARO',
'RAWALAKOT (AJK)',
'RAWALPINDI',
'RAWAT',
'RENALA KHURD',
'RISALPUR',
'ROHRI',
'RUBWA',
'SADIQABAD',
'SAFDARABAD',
'SAHIWAL',
'SAIDU SHARIF',
'SAJAWAL',
'SAKRAND',
'SAMANDARI',
'SANGHAR',
'SANGLA HILL',
'SANJWAL',
'SARAYE NORANG',
'SARDAR GARH',
'SARDARYAB',
'SARGODHA',
'SARI ALAMGIR',
'SATYYANA',
'SAWABI',
'SEHWAN SHARIF',
'SHABQADAR',
'SHADAD KOT',
'SHADIWAL',
'SHAH PUR CHAKAR',
'SHAHDAD PUR',
'SHAHKOT',
'SHAHPUR JAHANIA',
'SHAHPUR SADDAR',
'SHAKARGARH',
'SHAM KOT',
'SHAMS ABAD',
'SHANGLA',
'SHARAQPUR SHARIF',
'SHEEDO',
'SHEIKHUPURA',
'SHERGARH',
'SHEWA ADDA',
'SHIKARPUR',
'SHIMLA HILL',
'SHORKOT',
'SHUJABAD',
'SIALKOT',
'SIBI',
'SIHALA',
'SIKANDARABAD',
'SILANWALI',
'SIRAYE MUHAJIR',
'SKARDU',
'SMAAL IND ESTATE. DASKA',
'SOHAWA ONLY MAIN GT ROAD',
'SUDHANOTI (AJK)',
'SUKKUR',
'SUMBRIAL',
'SUNDER ADDA',
'SWABI',
'SWAT',
'SYED WALA',
'TAKHT-E-BHAI',
'TALAGUNG',
'TALHAR',
'TALVANDI',
'TANDLIAWALA',
'TANDO ADAM',
'TANDO ALLAHYAR',
'TANDO GHULAM ALI',
'TANDO JAM',
'TANDO JAN MUHAMMAD',
'TANDO MOHD KHAN',
'TANGI',
'TANK',
'TARBELA DAM',
'TARNOL',
'TAUNSA SHARIF',
'TAXLA',
'THATTA',
'THEENG MORE (ALLAHABAD)',
'THULL',
'TIBBA SULTANPURA',
'TIMARGARAH',
'TOBA TEK SINGH',
'TOPI (GIK UNIVERSITY AREA ONLY)*',
'TRANDA MOHAMMAD PANAH',
'TRANDA SAWAY KHAN',
'TULAMBA',
'TURBAT',
'UBARO',
'UCH SHRIF',
'UGGOKE',
'UMERKOT',
'USTA MUHAMMAD',
'VEHARI',
'VILLAGE SIAL',
'WAH CANTT',
'WAN RAHDA RAM',
'WAPDA COLONY (AJK)',
'WARBATTAN',
'WAZIRABAD',
'YAZMAN',
'ZAFARWAL',
'ZAHIR PIR',
'ZHOB'
];
var noSelectedOption = `<option id="noSelectedOption" value="0">Select City Name</option>`;
var cityNames = '';
var i;
for (i = 0; i < citiesList.length; i++) {
  cityNames += `<option value="${citiesList[i]}"> ${citiesList[i]}</option>`;
}
document.getElementById('cityNameDropdown').innerHTML =
  noSelectedOption + cityNames;
function cityDropdownValidation() {
  var checkSelectedDropdown = document.getElementById('cityNameDropdown')
    .selectedIndex;
  var cityNoSelectedValue = document.getElementsByTagName('option')[
    checkSelectedDropdown
  ].value;
  console.log(cityNoSelectedValue);
  if (cityNoSelectedValue == 0) {
    document.getElementById('cityDropdwonErrorText').style.display = 'block';
    // console.log(cityNoSelectedValue.value)
  } else {
    window.location = `/checkout?checkout[shipping_address][city]=${cityNoSelectedValue}`;
    document.getElementById('cityDropdwonErrorText').style.display = 'none';
  }
}
